// angular import
import { Component, DoCheck, OnInit } from '@angular/core';
import { animate, style, transition, trigger } from '@angular/animations';
import { ThemeConfig } from 'src/app/app-config';
import * as CryptoJS from 'crypto-js';
// bootstrap import
import { NgbDropdownConfig, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AuthenticationService } from 'src/app/theme/shared/service/authentication.service';
import { CommonService } from '../../../../../shared/common.service';
import { OAuthService } from 'angular-oauth2-oidc';
import { SubscriptionDataService } from '../../../../../shared/Subscription/subscription-data.service';
import { CompanyServiceService } from '../../../../../modules/company/companylist/company-service.service';
import { UserinformationService } from '../../../../../modules/tools/user-accounts/Services/userinformation.service';
import moment from 'moment';
import Swal from 'sweetalert2';
import { Router } from '@angular/router';
import { ApprovalstatusService } from '../../../../../modules/accounts/approvalstatus/service/approvalstatus.service';
import { FbidetailService } from '../../../../../modules/fbidetails/service/fbidetail.service';
import { ConfigurationService } from '../../../../../Configuration/configuration.service';
import { GlobalLogoutService } from '../../../../../shared/andicaCentralServices/global-logout.service';

@Component({
  selector: 'app-nav-right',
  templateUrl: './nav-right.component.html',
  styleUrls: ['./nav-right.component.scss'],
  providers: [NgbDropdownConfig],
  animations: [
    trigger('slideInOutLeft', [
      transition(':enter', [style({ transform: 'translateX(100%)' }), animate('300ms ease-in', style({ transform: 'translateX(0%)' }))]),
      transition(':leave', [animate('300ms ease-in', style({ transform: 'translateX(100%)' }))])
    ]),
    trigger('slideInOutRight', [
      transition(':enter', [style({ transform: 'translateX(-100%)' }), animate('300ms ease-in', style({ transform: 'translateX(0%)' }))]),
      transition(':leave', [animate('300ms ease-in', style({ transform: 'translateX(-100%)' }))])
    ])
  ]
})
export class NavRightComponent implements DoCheck, OnInit {
  // public props
  visibleUserList: boolean;
  chatMessage: boolean;
  friendId: boolean;
  config;
  companyName: any;
  Accountsstart: any
  accountsEnd: any

  ShowUpgrade: boolean = false;
  ShowRenew: boolean = false;
  headertags: boolean = false; companycount: any = 0; UserListcount: any = 0;
  APPeriodId: number;
  formid: any;
  IssubmissionStatus: any;
  // constructor
  constructor(private FbidetailService: FbidetailService, config: NgbDropdownConfig, private authenticationService: AuthenticationService, public common: CommonService, private ngbmodal: NgbModal, private oauthService: OAuthService,
    private subscriptionSrvice: SubscriptionDataService, private company: CompanyServiceService, private userservice: UserinformationService, private router: Router, private ApprovalstatusService: ApprovalstatusService, private configService: ConfigurationService
    , private globalLogoutService: GlobalLogoutService  ) {
    config.placement = 'bottom-right';
    this.visibleUserList = false;
    this.chatMessage = false;
    this.config = ThemeConfig;
    this.authenticationService.user.subscribe((x) => x);
    if (localStorage.getItem("legalFormId")) {
      this.formid = CryptoJS.AES.decrypt(localStorage.getItem("legalFormId"), "APS").toString(CryptoJS.enc.Utf8)
    }
  }
  ngOnInit(): void {
    debugger
    if (!this.common.deactivated && window.location.pathname != '/business') {
      var Session_Object = JSON.parse(sessionStorage.getItem('id_token_claims_obj'));
      this.common.getLoginDetails(Session_Object.emails[0]);
    }

    this.company.getAPPeriodId.subscribe(data => {
      if (data) {
        this.APPeriodId = CryptoJS.AES.decrypt(localStorage.getItem("APPeriodId"), "APS").toString(CryptoJS.enc.Utf8);
      }
      else if (data == 0) {
        if (localStorage.getItem("APPeriodId"))
          this.APPeriodId = CryptoJS.AES.decrypt(localStorage.getItem("APPeriodId"), "APS").toString(CryptoJS.enc.Utf8);
      }
      else {
        this.APPeriodId = null;
      }
    });
    this.getLoginCredentials();
  }

  // public method
  onChatToggle(friend_id) {
    this.friendId = friend_id;
    this.chatMessage = !this.chatMessage;
  }

  // life cycle event
  ngDoCheck() {
    if (document.querySelector('body').classList.contains('datta-rtl')) {
      this.config['rtl-layout'] = true;
    } else {
      this.config['rtl-layout'] = false;
    }

    this.companyName = localStorage.getItem("CompanyName");

    this.Accountsstart = localStorage.getItem("accountsstart")
    this.accountsEnd = localStorage.getItem("accountsend")

  }

  //logout() {
  //  this.authenticationService.logout();
  //}
  BusinessList() {
    debugger
    //this.common.setLoadBusiness(true)
  }
  UserLicense(content) {
    debugger
    var Session_Object = JSON.parse(sessionStorage.getItem('id_token_claims_obj'));
    var UserMaster_Loginname = Session_Object.emails[0];
    this.common.getLoginDetails(UserMaster_Loginname)
    this.company.getAllCompanies(localStorage.getItem('MasterId')).subscribe((data: any) => {
      if (data) {
        var result: any
        result = Array.from(data.reduce((m, t) => m.set(t.CompanyID, t), new Map()).values());
        // this.companycount = result.filter(x => x.CreatedBy == this.common.UserId).length
        this.companycount = result.filter(x => x.CreatedBy == localStorage.getItem("MasterId") && x.CompanyCount == 1).length
      }
    })
    this.userservice.getUsersList(localStorage.getItem('MasterId')).subscribe((data: any) => {
      if (data) {
        this.UserListcount = data.filter(x => (x.CentralUserId == localStorage.getItem("MasterId") || x.CreatedBy == localStorage.getItem("MasterId")))
        this.UserListcount = this.UserListcount.length;
      }
    })
    this.ngbmodal.open(content, { size: 'lg', centered: true, keyboard: false, backdrop: 'static' })
  }
  Cancel() {
    this.ngbmodal.dismissAll()
  }
  logout() {

    //if (!location.href.includes('localhost')) {
    //  window.location.href = this.configService.andicaCentralURL();
    //} else {
    this.globalLogoutService.publishLogout();
    sessionStorage.setItem('ProductLogedout', 'Yes')
      this.common.logOut();
    //}
  }
  Upgrade(type: string) {

    this.subscriptionSrvice.Upgrade(type, this.common.centralUserId, this.common.ProductId, this.common.NumberOfCompanies, this.common.NumberOfUsers, this.common.PlanId, this.common.PricingId, this.common.TaxYear)
  }

  Statuschange() {
    debugger;
    this.APPeriodId = CryptoJS.AES.decrypt(localStorage.getItem("APPeriodId"), "APS").toString(CryptoJS.enc.Utf8);

  }
  getLoginCredentials() {
    var Registrationumber = localStorage.getItem("companyRegistrationNumber")
    this.FbidetailService.getFbiDetails(CryptoJS.AES.decrypt(localStorage.getItem("APPeriodId"), "APS").toString(CryptoJS.enc.Utf8)).subscribe((data: any) => {
      if (data != null) {
        var submitdata = data
        if (submitdata.length > 0) {
          var CheckStatus = submitdata.filter(x => x.APPeriodId == CryptoJS.AES.decrypt(localStorage.getItem("APPeriodId"), "APS").toString(CryptoJS.enc.Utf8))[0].FBIStatus
          if (CheckStatus) {
            //this.IssubmissionStatus = submitdata[0].FBIStatus == 'Rejected by CoHse' ? "null" : submitdata[0].FBIStatus
            this.IssubmissionStatus = submitdata[0].FBIStatus = submitdata[0].FBIStatus
          }
          else {
            this.IssubmissionStatus = "null"
          }
        }
      }
    })
  }
  Onlnsubmisiion() {
    debugger;

    if (this.IssubmissionStatus != "null" && this.IssubmissionStatus != undefined && this.IssubmissionStatus != 'Rejected by CoHse') {

      Swal.fire({
        title: 'Andica Accounts Production',
        html: 'Your Accounts may have already been submitted.<br>Click OK to Preview or Print the earleir submission receipt.<br>Click Cancel to abort this submission process.',
        icon: 'question',
        showCancelButton: true,
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        allowOutsideClick: false
      }).then((result) => {
        if (result.value) {
          this.router.navigate(['fbireceipt'])
        } else {
          return
        }
      })
    } else {
      if (this.common.AccountTemplateId == 9 || this.formid == "3") {      //9 testing with 3
        Swal.fire('Andica Accounts Production', "Currently Companies House does not support Sole Trader type of company.", "warning")
        //return true;
      }
      else if (this.common.AccountTemplateId == 10 || this.formid == "4") {
        Swal.fire('Andica Accounts Production', "Currently Companies House does not support Partnership type of company.", "warning")
        //return true;
      }
      else {
        this.ApprovalstatusService.GetOneTaxation(this.APPeriodId).subscribe((data: any) => {
          if (data.Item2.Status) {
            localStorage.setItem("submitted", "true")
            this.router.navigate(["fbidetail"])
          }
          else {
            Swal.fire("Andica Accounts Production", "Accounts forms are incomplete. Complete the same before submitting to Companies House.", "warning")
          }
        })
      }
    }
  }
  user(event?) {
    debugger
    this.common.MouseEvent = event

    this.router.navigate(["user-accounts"])
  }
  helpFileClick(event?) {
    debugger;
    //this.router.navigate(["D:\Andica_Accounts_Production\Andica-Accounts-Production-Dev-Branch\Andica_Accounts_Production\ClientApp\src\app\APS-User-Guidlines\index.html"]);
    const url = `assets/APS-User-Guidlines/index.html`;
    window.open(url, '_blank', 'width=1200,height=800,top=500');
  }
  andicaCentral_navigate() {
    debugger
    var URL = this.configService.andicaCentralURL();
    window.open(URL, '_self');
  }
}
